/* eslint-disable no-console */
import axios from 'axios';
import qs from 'qs';
import { Message } from 'element-ui';
import { AES, Base64, DES, md5 } from '../crypto/';
import { localStorageUtil } from '../storage';
import Config from '../config';
import router from '../../router';

export function getData(url, method, object, callback, period) {
  const paramobj = {};
  paramobj.appId = Config.CommonParams.appId;
  paramobj.method = method;
  paramobj.timestamp = new Date().getTime();
  paramobj.clienttype = Config.CommonParams.clienttype;
  const newobject = {};
  Object.keys(object)
    .sort()
    .map((item) => {
      newobject[item] = object[item];
      return newobject;
    });
  paramobj.object = newobject;
  let secret =
    paramobj.appId + paramobj.method + paramobj.timestamp + paramobj.clienttype + JSON.stringify(paramobj.object);
  secret = md5(secret);
  paramobj.secret = secret;
  const paramtext = JSON.stringify(paramobj);
  const paramciphertext = AES.encrypt(paramtext, Config.key.aes_local_key, Config.key.aes_local_iv);

  // console.log('参数对象:', paramtext);
  // console.log('参数密文:', paramciphertext);

  let param = 'param=' + paramciphertext;
  param = param.replace(/\+/g, '%2B');
  param = decodeURI(param);
  // console.log('传递参数:', param);

  axios(url, {
    headers: {
      Accept: 'text/plain',
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
    },
    method: 'POST',
    data: param,
  })
    .then((res) => {
      // console.log('返回结:', res);
      return res.data;
    })
    .then((res) => {
      if (typeof res === 'string') {
        // console.log('返回结果密文:', res);
        let text = AES.decrypt(res, Config.key.aes_server_key, Config.key.aes_server_iv);
        // console.log('AES解码:', text);
        text = DES.decrypt(text, Config.key.des_client_key, Config.key.des_client_iv);
        // console.log('DES解码:', text);
        text = Base64.decrypt(text);
        // console.log('返回明文结果:', text, JSON.parse(text));
        callback(text);
      } else if (Object.prototype.toString.call(res) === '[object Object]' && 'success' in res) {
        callback(JSON.stringify(res));
      }
    })
    .catch((res) => {
      // Message({ message: res, type: 'error', duration: 5000 })
      console.log('其他异常:', url, method, object, res);
      // throw new Error(res);
    });
}

function getDataFromLocalStorage(key, period) {
  if (typeof period === 'undefined') {
    period = 0;
  }
  let data = localStorageUtil.getValue(key);
  if (data) {
    // 判断是否过期
    const time = data.time;
    const current = new Date().getTime();
    if (new Date().getHours() >= 0 && new Date().getHours() < 5) {
      period = 1;
    }
    if (current - period * 60 * 60 * 1000 > time) {
      // 更新
      data = null;
    }
    // 防止1-5点用户不打开页面，跨天的情况
    if (new Date().getHours() >= 5 && new Date(time).getDate() !== new Date().getDate() && period === 24) {
      data = null;
    }
  }
  return data;
}

export function getServerData(url, method, object, callback, period) {
  url = Config.host + url;
  const key = md5(url + method + JSON.stringify(object));
  const data = getDataFromLocalStorage(key, period);
  if (!data) {
    getData(
      url,
      method,
      object,
      (text) => {
        const resultobj = JSON.parse(text);
        if (resultobj.errcode === 0) {
          // if (period > 0) {
          //     resultobj.result.time = new Date().getTime(); // 添加当前时间
          //     localStorageUtil.save(key, resultobj.result);
          // }
          callback(resultobj.result || []);
        } else {
          Message({ message: resultobj.errmsg, type: 'error', duration: 5000 });
          console.log('业务逻辑异常:', resultobj.errmsg);
        }
      },
      period,
    );
  } else {
    callback(data);
  }
}

export function getJapiServerData(url, object, method, callback, period) {
  return new Promise((resolve, reject) => {
    url = Config.jhost + url;
    const that = this;
    let xhr = new XMLHttpRequest();
    xhr.open(method, url);
    // xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded')
    xhr.setRequestHeader('Access-Control-Allow-Origin', '*');
    if (!url.includes('login')) {
      xhr.setRequestHeader('token', localStorage.getItem('token'));
    }

    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded'); // 设置请求头
    xhr.send(qs.stringify(object));
    xhr.onreadystatechange = () => {
      if (xhr.readyState === 4 && xhr.status === 200) {
        //固定写法
        //数据获取成功，获取服务器响应的数据
        const res = JSON.parse(xhr.responseText);
        if (res.code == 1003) {
          console.log(this);
          Message({ message: '用户信息过期请重新登陆', type: 'error', duration: 5000 });
          router.push('/login');
        } else {
          callback && callback(res || []);
          resolve(res || []);
        }
      }
    };
  });
}

export default {
  getData,
  getServerData,
  getJapiServerData,
};
